import { render, staticRenderFns } from "./MenuTop.vue?vue&type=template&id=5a866dea"
import script from "./MenuTop.vue?vue&type=script&lang=js"
export * from "./MenuTop.vue?vue&type=script&lang=js"
import style0 from "./MenuTop.vue?vue&type=style&index=0&id=5a866dea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports